import React from "react";
import { useNavigate } from "react-router-dom";
import { IoMdArrowBack } from "react-icons/io";
import { FiCheckCircle, FiShield, FiMail, FiPackage } from "react-icons/fi";

const Termsandcondition = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-[#F8F9FA] flex flex-col relative overflow-hidden">
      {/* Decorative Blur (Matching Sell Product) */}
      <div className="absolute top-[-5%] right-[-10%] w-80 h-80 bg-orange-100 rounded-full blur-3xl opacity-40"></div>

      {/* Unified Header */}
      <div className="bg-white px-6 py-6 flex items-center shadow-sm border-b border-gray-100 relative z-20">
        <button 
          onClick={() => navigate(-1)} 
          className="p-2 -ml-2 hover:bg-gray-100 rounded-full transition text-gray-900"
        >
          <IoMdArrowBack size={24} />
        </button>
        <div className="ml-4">
          <h1 className="text-[10px] font-black uppercase tracking-[0.2em] text-orange-600">Company</h1>
          <p className="text-xl font-black text-gray-900 tracking-tighter">Terms & Conditions</p>
        </div>
      </div>

      {/* Content Container */}
      <div className="flex-1 p-4 max-w-2xl mx-auto w-full relative z-10 pt-8 pb-20">
        <div className="bg-white rounded-[2.5rem] p-6 md:p-10 shadow-xl shadow-gray-200/50 border border-gray-100 space-y-10">
          
          <div className="space-y-4">
            <p className="text-sm font-bold text-gray-600 leading-relaxed">
              Welcome to <span className="text-orange-600 font-black">OurASAP</span>! By accessing or using our services, you agree to comply with the following terms. Please read them carefully.
            </p>
          </div>

          {/* Section 1 */}
          <div className="space-y-4">
            <div className="flex items-center gap-2">
              <div className="w-8 h-8 bg-orange-50 rounded-lg flex items-center justify-center text-orange-600">
                <FiCheckCircle size={16} />
              </div>
              <h3 className="text-[11px] font-black uppercase tracking-widest text-gray-900">1. Use of Services</h3>
            </div>
            <p className="text-sm text-gray-600 font-bold leading-relaxed ml-10">
              You agree to use our services only for lawful purposes. You must not misuse our services or interfere with them in any way.
            </p>
          </div>

          {/* Section 2 */}
          <div className="space-y-4">
            <div className="flex items-center gap-2">
              <div className="w-8 h-8 bg-orange-50 rounded-lg flex items-center justify-center text-orange-600">
                <FiShield size={16} />
              </div>
              <h3 className="text-[11px] font-black uppercase tracking-widest text-gray-900">2. Account Responsibility</h3>
            </div>
            <p className="text-sm text-gray-600 font-bold leading-relaxed ml-10">
              You are responsible for maintaining the confidentiality of your account credentials and for all activities that occur under your account.
            </p>
          </div>

          {/* Section 3 */}
          <div className="space-y-4">
            <div className="flex items-center gap-2">
              <div className="w-8 h-8 bg-orange-50 rounded-lg flex items-center justify-center text-orange-600">
                <span className="font-black text-xs">₦</span>
              </div>
              <h3 className="text-[11px] font-black uppercase tracking-widest text-gray-900">3. Payments</h3>
            </div>
            <p className="text-sm text-gray-600 font-bold leading-relaxed ml-10">
              All payments for orders must be made through our platform. Any payments made outside of OurASAP are not covered by our insurance or support.
            </p>
          </div>

          {/* Section 4 */}
          <div className="space-y-4">
            <div className="flex items-center gap-2">
              <div className="w-8 h-8 bg-orange-50 rounded-lg flex items-center justify-center text-orange-600">
                <FiPackage size={16} />
              </div>
              <h3 className="text-[11px] font-black uppercase tracking-widest text-gray-900">4. Delivery & Liability</h3>
            </div>
            <p className="text-sm text-gray-600 font-bold leading-relaxed ml-10">
              While we aim to ensure timely and accurate deliveries, we are not responsible for delays, damages, or losses caused by circumstances beyond our control.
            </p>
          </div>

            <div className="space-y-4">
            <div className="flex items-center gap-2">
              <div className="w-8 h-8 bg-orange-50 rounded-lg flex items-center justify-center text-orange-600">
                <FiPackage size={16} />
              </div>
              <h3 className="text-[11px] font-black uppercase tracking-widest text-gray-900">5. Seller Responsibility</h3>
            </div>
            <p className="text-sm text-gray-600 font-bold leading-relaxed ml-10">
           Sellers are responsible for ensuring that product information, pricing, and availability listed on OurASAP are accurate. OurASAP reserves the right to remove fraudulent or misleading listings.
            </p>
          </div>


  <div className="space-y-4">
            <div className="flex items-center gap-2">
              <div className="w-8 h-8 bg-orange-50 rounded-lg flex items-center justify-center text-orange-600">
                <FiPackage size={16} />
              </div>
              <h3 className="text-[11px] font-black uppercase tracking-widest text-gray-900">6. Platform Communications</h3>
            </div>
            <p className="text-sm text-gray-600 font-bold leading-relaxed ml-10">
By using OurASAP, users agree to receive essential communications related to account activity, orders, payments, security, and platform updates.
            </p>
          </div>


          {/* Contact Section */}
          <div className="pt-6 border-t border-gray-100 space-y-4">
            <div className="flex items-center gap-2">
              <div className="w-8 h-8 bg-gray-900 rounded-lg flex items-center justify-center text-white">
                <FiMail size={16} />
              </div>
              <h3 className="text-[11px] font-black uppercase tracking-widest text-gray-900">Contact Us</h3>
            </div>
            <p className="text-sm text-gray-600 font-bold ml-10">
              Questions regarding these Terms? Contact us at: <br />
              <span className="text-orange-600">ourasapservice@gmail.com</span>
            </p>
          </div>

          <p className="text-[10px] font-black text-gray-400 uppercase tracking-widest text-center pt-4">
            &copy; {new Date().getFullYear()} OurASAP. All rights reserved.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Termsandcondition;